import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import LocationPicker from "../components/LocationPicker";
import { FiShoppingCart } from "react-icons/fi";
import { FiPackage } from "react-icons/fi";
// import { FiTruck } from "react-icons/fi";
import { MdShoppingCart } from "react-icons/md";
import { MdLocalShipping } from "react-icons/md";
import { FiUser } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { FiMapPin } from "react-icons/fi";
import { MdOutlineShoppingCartCheckout } from "react-icons/md";
import { FaShoppingBasket } from "react-icons/fa";
import { FaCookieBite } from "react-icons/fa";
import { FaCoffee } from "react-icons/fa";
import { FaPumpSoap } from "react-icons/fa";
import { FaSoap } from "react-icons/fa";
import { FaUtensils } from "react-icons/fa";
import { FaBroom } from "react-icons/fa";
import { FaGlassWhiskey } from "react-icons/fa";
import { FaStore } from "react-icons/fa";
import { FiCheckCircle } from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { io } from "socket.io-client";
import { GiMilkCarton } from "react-icons/gi";
import { FiSearch } from "react-icons/fi";
// import { FiAlertTriangle } from "react-icons/fi";
// import { FiInfo } from "react-icons/fi";
import { FiArrowUp } from "react-icons/fi";
import { MdBlock } from "react-icons/md";
// import { FiPlus, FiMinus } from "react-icons/fi";
import { FiShoppingBag } from "react-icons/fi";
import { useMemo } from "react";




function Products() {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [search, setSearch] = useState("");
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [location, setLocation] = useState(null);
  const [showSearch, setShowSearch] = useState(true);
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [justAdded, setJustAdded] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [orderType, setOrderType] = useState("delivery"); // "pickup" or "delivery"
  const [debouncedSearch, setDebouncedSearch] = useState(search);


  const imgRefs = useRef({});

  const lastScrollY = useRef(0);

  const SHOP_OPEN_HOUR = 8;   // 8 AM
  const SHOP_CLOSE_HOUR = 21; // 9 PM

  const MIN_ORDER_AMOUNT = 0;
  const DELIVERY_THRESHOLD = 200;
  const DELIVERY_FEE = 20;

  const cartRef = useRef(null);
  const cartSectionRef = useRef(null);
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({
    customerName: "",
    phone: "",
    address: "",
    note: ""
  });



  useEffect(() => {

    fetchProducts();

    const savedCustomer = localStorage.getItem("customer");

    if (savedCustomer) {
      const data = JSON.parse(savedCustomer);

      setCustomer({
        customerName: data.customerName || "",
        phone: data.phone || "",
        address: data.address || "",
        // note: data.note || ""
      });
    }

    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }

  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const diff = currentScrollY - lastScrollY.current;

      // 🔥 ignore tiny movements (prevents jitter + delay)
      if (Math.abs(diff) < 5) return;

      if (diff > 0) {
        // scrolling DOWN
        setShowSearch(false);
      } else {
        // scrolling UP
        setShowSearch(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_URL, {
      // transports: ["websocket"], // 🔥 VERY IMPORTANT
      // withCredentials: true
    }); // change if deployed

    // 🔥 PRODUCT UPDATED
    socket.on("productUpdated", (updatedProduct) => {

      setProducts(prev =>
        prev.map(p =>
          p._id === updatedProduct._id ? updatedProduct : p
        )
      );

      setCart(prevCart => {

        let changed = false;

        const updated = prevCart
          .map(item => {

            if (item._id !== updatedProduct._id) return item;

            if (updatedProduct.stock === 0) {
              changed = true;
              return null;
            }

            if (item.quantity > updatedProduct.stock) {
              changed = true;
            }

            return {
              ...item,
              stock: updatedProduct.stock,
              quantity: Math.min(item.quantity, updatedProduct.stock)
            };
          })
          .filter(Boolean);

        if (changed) {
          setTimeout(() => {
            toast.info("Cart updated due to stock changes");
          }, 0);
        }

        return updated;
      });

    });
    // 🔥 PRODUCT DELETED
    socket.on("productDeleted", (deletedId) => {

      setProducts(prev =>
        prev.filter(p => p._id !== deletedId)
      );

      setCart(prevCart => {

        const exists = prevCart.find(i => i._id === deletedId);

        const updated = prevCart.filter(i => i._id !== deletedId);

        if (exists) {
          setTimeout(() => {
            toast.info("Cart updated (product removed)");
          }, 0);
        }

        return updated;
      });

    });



    return () => socket.disconnect();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 250); // 🔥 delay

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300); // show after scrolling
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const fetchProducts = async () => {
    const res = await API.get("/products");
    const latestProducts = res.data.filter(p => p.active !== false);

    setProducts(latestProducts);



    setCart(prevCart => {

      let cartChanged = false;

      const updatedCart = prevCart
        .map(item => {
          const latest = latestProducts.find(p => p._id === item._id);

          if (!latest || latest.stock === 0) {
            cartChanged = true;
            return null;
          }

          if (item.quantity > latest.stock) {
            cartChanged = true;
          }

          return {
            ...item,
            stock: latest.stock,
            quantity: Math.min(item.quantity, latest.stock)
          };
        })
        .filter(Boolean);

      if (cartChanged) {
        setTimeout(() => {
          toast.info("Cart updated due to stock changes");
        }, 0);
      }

      return updatedCart;
    });



    setLoading(false);
  };

  const addToCart = (product) => {
    if (product.active === false || product.stock === 0) {
      toast.error("Out of stock");
      return;
    }

    navigator.vibrate?.(40);

    const variantKey = product.selectedVariant
      ? `${product._id}-${product.selectedVariant.quantity}`
      : product._id;

    const existing = cart.find(item => item.key === variantKey);

    if (existing) {
      if (existing.quantity >= product.stock) return;

      setCart(cart.map(item =>
        item.key === variantKey
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([
        ...cart,
        {
          ...product,
          key: variantKey,
          price: product.selectedVariant?.price || product.price,
          packSize: product.selectedVariant?.quantity || product.packSize,
          unit: product.selectedVariant?.unit || product.unit,
          quantity: 1
        }
      ]);
    }
  };

  const flyToCart = (imgRect) => {
    const cart = cartRef.current;
    if (!cart) return;

    const cartRect = cart.getBoundingClientRect();

    const flyer = document.createElement("div");

    const startX = imgRect.left + imgRect.width / 2;
    const startY = imgRect.top + imgRect.height / 2;

    const endX = cartRect.left + cartRect.width / 2;
    const endY = cartRect.top + cartRect.height / 2;

    const deltaX = endX - startX;
    const deltaY = endY - startY;

    console.log(deltaX, deltaY);

    flyer.style.position = "fixed";
    flyer.style.left = startX - 15 + "px"; // center align (30px / 2)
    flyer.style.top = startY - 15 + "px";
    flyer.style.width = "30px";
    flyer.style.height = "30px";
    flyer.style.background = "#16a34a";
    flyer.style.borderRadius = "50%";
    flyer.style.zIndex = 9999;
    flyer.style.pointerEvents = "none";

    // 🔥 IMPORTANT
    flyer.style.transition = "transform 1s cubic-bezier(0.2, 1, 0.3, 1), opacity 0.6s";

    document.body.appendChild(flyer);

    // force browser to register initial position
    flyer.getBoundingClientRect();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
        flyer.style.opacity = "0.5";
      });
    });

    // cart bounce
    cart.animate(
      [
        { transform: "scale(1)" },
        { transform: "scale(1.2)" },
        { transform: "scale(1)" }
      ],
      { duration: 200 }
    );

    setTimeout(() => {
      flyer.remove();
    }, 1000);
  };

  const removeFromCart = (key) => {
    setCart(cart.filter(item => item.key !== key));
  };

  const decreaseQuantity = (product) => {
    const key = product.key;

    const existing = cart.find(item => item.key === key);

    if (existing.quantity === 1) {
      removeFromCart(key);
    } else {
      setCart(cart.map(item =>
        item.key === key
          ? { ...item, quantity: item.quantity - 1 }
          : item
      ));
    }
  };

  const handleCustomerChange = (e) => {

    const updatedCustomer = {
      ...customer,
      [e.target.name]: e.target.value
    };

    setCustomer(updatedCustomer);

    localStorage.setItem("customer", JSON.stringify(updatedCustomer));

  };

  const totalPrice = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const deliveryFee =
    orderType === "delivery"
      ? (totalPrice >= DELIVERY_THRESHOLD ? 0 : DELIVERY_FEE)
      : 0;

  const finalTotal = totalPrice + deliveryFee;
  // const progress = Math.min((totalPrice / DELIVERY_THRESHOLD) * 100, 100);

  const [placingOrder, setPlacingOrder] = useState(false);

  const isShopOpen = () => {
    const now = new Date();
    const hour = now.getHours();

    return hour >= SHOP_OPEN_HOUR && hour < SHOP_CLOSE_HOUR;
  };

  const validateOrder = (currentType) => {

    if (!isShopOpen()) {
      toast.error("Shop is closed. Please order during working hours");
      return false;
    }

    if (cart.length === 0) {
      toast.error("Cart is empty");
      return false;
    }

    if (!customer.customerName.trim()) {
      toast.error("Please enter your name");
      return false;
    }

    const phone = customer.phone.replace(/\D/g, "");

    if (!phone) {
      toast.error("Please enter phone number");
      return false;
    }

    if (!/^[6-9]\d{9}$/.test(phone)) {
      toast.error("Enter valid 10-digit phone number");
      return false;
    }

    if (currentType === "delivery") {

      if (!location?.lat || !location?.lng) {
        toast.info("Please choose your location on map");
        setShowMap(true);
        return false;
      }

      if (!customer.address?.trim()) {
        toast.error("Please enter delivery address");
        return false;
      }
    }

    if (totalPrice < MIN_ORDER_AMOUNT) {
      toast.error(`Minimum order is ₹${MIN_ORDER_AMOUNT}`);
      return false;
    }

    return true;
  };

  const placeOrder = async (currentType) => {

    // 🚫 Shop closed check

    const cleanPhone = customer.phone.replace(/\D/g, "");


    if (placingOrder) return;









    try {
      setPlacingOrder(true);

      // 🔥 NEW: Fetch latest products
      const res = await API.get("/products");
      const latestProducts = res.data;

      // 🔥 NEW: Validate cart with latest stock
      for (let item of cart) {
        const latest = latestProducts.find(p => p._id === item._id);

        if (!latest || latest.stock === 0) {
          toast.error(`${item.name} is out of stock`);
          return;
        }

        if (item.quantity > latest.stock) {
          toast.error(`Only ${latest.stock} ${item.name} available`);

          // auto-fix cart
          setCart(prev =>
            prev.map(p =>
              p._id === item._id
                ? { ...p, quantity: latest.stock }
                : p
            )
          );

          return;
        }
      }

      // ✅ ORIGINAL CODE CONTINUES

      const items = cart.map(item => ({
        productId: item._id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        packSize: item.packSize,
        unit: item.unit
      }));

      const orderData = {
        customerName: customer.customerName,
        phone: cleanPhone,
        address: customer.address,
        note: customer.note,

        orderType: currentType, // ✅ HERE

        items,
        totalPrice: finalTotal,

        location: currentType === "delivery"
          ? {
            lat: location?.lat,
            lng: location?.lng,
            address: customer.address
          }
          : null
      };

      await API.post("/orders", orderData);

      setOrderPlaced(true);
      setCart([]);
      localStorage.removeItem("cart");

      setLocation(null);
      setShowMap(false);

    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to place order");
    } finally {
      setPlacingOrder(false);
    }
  };

  const cartCount = cart.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const scrollToCart = () => {
    cartSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };

  const categoryOrder = [
    "All",
    "Groceries",
    "Dairy",
    "Snacks",
    "Beverages",
    "Tea & Coffee",
    "Personal Care",
    "Laundry",
    "Dishwashing",
    "Home & Household"
  ];

  const categories = categoryOrder.filter(
    cat => cat === "All" || products.some(p => p.category === cat)
  );

  const normalize = (text) =>
    text.toLowerCase().replace(/\s+/g, " ").trim();

  const fuzzyMatch = (text, word) => {
    // simple typo tolerance (1 char difference)
    for (let i = 0; i < text.length - word.length + 1; i++) {
      const part = text.substring(i, i + word.length);

      let diff = 0;
      for (let j = 0; j < word.length; j++) {
        if (part[j] !== word[j]) diff++;
        if (diff > 1) break;
      }

      if (diff <= 1) return true;
    }

    return false;
  };

  const getSearchScore = useCallback((productName, search) => {
    const name = normalize(productName);
    const query = normalize(search);

    if (!query) return 1;

    const words = query.split(" ");

    let score = 0;

    if (name === query) score += 100;
    if (name.startsWith(query)) score += 50;

    const allWordsMatch = words.every(w => name.includes(w));
    if (allWordsMatch) score += 30;

    words.forEach(w => {
      if (name.includes(w)) score += 10;
    });

    words.forEach(w => {
      if (!name.includes(w) && w.length > 3) {
        if (fuzzyMatch(name, w)) score += 5;
      }
    });

    return score;

  }, []);

  const filteredProducts = useMemo(() => {

    let result = products
      .filter(p => p.active !== false)
      .filter(product =>
        selectedCategory === "All" || product.category === selectedCategory
      );

    if (debouncedSearch.trim().length >= 2) {
      result = result
        .map(product => {
          const score =
            getSearchScore(product.name, debouncedSearch) +
            0.5 * getSearchScore(product.category, debouncedSearch);

          return { ...product, score };
        })
        .filter(p => p.score > 0)
        .sort((a, b) => b.score - a.score);
    }

    return result;

  }, [products, selectedCategory, debouncedSearch, getSearchScore]);

  const getQuantity = (productId, variantQty = null) => {
    const key = variantQty ? `${productId}-${variantQty}` : productId;
    const item = cart.find(i => i.key === key);
    return item ? item.quantity : 0;
  };

  if (orderPlaced) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f7f7",
        padding: "20px"
      }}>

        <div style={{
          background: "white",
          padding: "30px 25px",
          borderRadius: "16px",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          maxWidth: "400px",
          width: "100%"
        }}>

          {/* ✅ Icon */}
          <div style={{
            width: "72px",
            height: "72px",
            margin: "0 auto 18px",
            borderRadius: "50%",
            background: "#ecfdf5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 20px rgba(22,163,74,0.2)"
          }}>
            <FiCheckCircle
              size={40}
              color="#16a34a"
              className="success-icon"
            />
          </div>

          {/* Title */}
          <h2 style={{
            marginBottom: "10px",
            fontSize: "24px",
            fontWeight: "800",
            color: "#111",
            fontFamily: "'Nunito', sans-serif",
            letterSpacing: "0.3px"
          }}>
            Order Placed Successfully
          </h2>

          {/* Subtitle */}
          <p style={{
            fontSize: "14px",
            color: "#4b5563",
            marginBottom: "20px",
            fontFamily: "'Inter', sans-serif"
          }}>
            {orderType === "delivery"
              ? "Your order will be delivered soon 🚚"
              : "We’ve received your order. We’ll notify you when it’s ready for pickup."}
          </p>

          {/* Divider */}
          <div style={{
            height: "1px",
            background: "#eee",
            margin: "15px 0"
          }} />

          {/* Actions */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}>

            <button
              onClick={() => navigate("/orders")}
              style={{
                background: "#111827",
                color: "white",
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                fontWeight: "700",
                cursor: "pointer",
                fontFamily: "'Nunito', sans-serif",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px"
              }}
            >
              <FiPackage size={18} /> View Orders
            </button>

            <button
              onClick={() => setOrderPlaced(false)}
              style={{
                background: "#16a34a",
                color: "white",
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                fontWeight: "700",
                cursor: "pointer",
                fontFamily: "'Nunito', sans-serif"
              }}
            >
              Continue Shopping
            </button>

          </div>

        </div>
      </div>
    );
  }

  const categoryIcons = {
    All: <FaStore />,
    Dairy: <GiMilkCarton />,
    Groceries: <FaShoppingBasket />,
    Snacks: <FaCookieBite />,
    "Tea & Coffee": <FaCoffee />,
    Beverages: <FaGlassWhiskey />,
    "Personal Care": <FaPumpSoap />,
    Laundry: <FaSoap />,
    Dishwashing: <FaUtensils />,
    "Home & Household": <FaBroom />
  };

  const capitalizeWords = (text) => {
    if (!text) return "";

    return text
      .split(" ")
      .map(word => {
        if (!word) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const formatHour = (hour) => {
    const ampm = hour >= 12 ? "PM" : "AM";
    const formatted = hour % 12 || 12;
    return `${formatted}:00 ${ampm}`;
  };





  return (
    <div
      style={{
        padding: "12px",
        paddingBottom: "100px",
        maxWidth: "1000px",
        margin: "auto",
        background: "#f7f7f7",
        minHeight: "100vh"
      }}
    >



      <div
        style={{
          position: "sticky",
          top: 0,

          zIndex: 100,
          padding: "10px 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
          gap: "10px",
          background: "rgba(247,247,247,0.9)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid #eee",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          transition: "all 0.25s ease",
        }}
      >

        <div style={{ lineHeight: "1.1" }}>
          <h1 style={{
            fontSize: "24px",
            fontWeight: "900",
            fontFamily: "'Nunito', sans-serif",
            margin: 0,
            color: "#111",
            letterSpacing: "0.3px",
            textRendering: "optimizeLegibility",
          }}>
            <span style={{ fontWeight: "900" }}>Manasa</span>{" "}
            <span style={{ fontWeight: "500", opacity: 0.9 }}>Stores</span>
          </h1>

          <p style={{
            margin: 0,
            fontSize: "11px",
            color: "#666",
            fontWeight: "500"
          }}>
            Fresh. Local. Daily.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
        >

          <button
            onClick={() => navigate("/orders")}

            onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.96)"}
            onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
            onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}

            style={{
              background: "white",
              color: "#111827",
              // border: "none",
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              border: "1px solid #eee",
              transition: "transform 0.1s ease"
            }}
          >
            <FiPackage size={16} />
            Orders
          </button>

          <div
            ref={cartRef}
            style={{
              position: "relative",
              background: "#111827",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              cursor: "pointer",
              color: "white",
              padding: "8px 10px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={scrollToCart}
          >
            <MdShoppingCart size={20} />

            {cartCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  background: "#ef4444",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "10px",
                  padding: "2px 6px"
                }}
              >
                {cartCount}
              </span>
            )}

          </div>

        </div>

      </div>

      {/* 🚫 SHOP CLOSED BANNER */}
      {!isShopOpen() && (
        <div style={{
          background: "#fef2f2",  // softer red
          color: "#b91c1c",    // darker red
          padding: "10px",
          borderRadius: "10px",
          textAlign: "center",
          fontWeight: "600",
          marginBottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px"
        }}>
          <MdBlock size={18} />
          <span>
            {`Closed now • Opens at ${formatHour(SHOP_OPEN_HOUR)}`}
          </span>
        </div>
      )}



      {cartCount > 0 && (

        <div
          onClick={scrollToCart}
          style={{
            position: "fixed",
            bottom: "0",
            left: "0",
            right: "0",
            background: "#0aad0a",
            color: "white",
            padding: "12px 16px",
            fontSize: "14px",
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 1000,

            userSelect: "none",
            WebkitUserSelect: "none",
            touchAction: "manipulation",
          }}
        >

          <span style={{ display: "flex", alignItems: "center" }}>
            <FiShoppingCart size={20} style={{ marginRight: "5px" }} />
            {cartCount} {cartCount === 1 ? "item" : "items"}

            {deliveryFee !== 0 && (
              <span style={{ fontSize: "12px", marginLeft: "6px" }}>
                | ₹{DELIVERY_THRESHOLD - totalPrice} for free delivery
              </span>
            )}
          </span>
          <span>₹{finalTotal} | View Cart</span>

        </div>

      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))",
          gap: "12px",
          marginBottom: "18px"
        }}
      >

        {/* Minimum Order */}

        {/* <div
          style={{
            background: "white",
            padding: "12px",
            borderRadius: "12px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
        >

          <div
            style={{
              background: "#e8f7e8",
              color: "#333",
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px"
            }}
          >
            <FiShoppingCart />
          </div>

          <div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Minimum order
            </div>
            <div style={{ fontWeight: "bold", fontSize: "16px" }}>
              ₹{MIN_ORDER_AMOUNT}
            </div>
          </div>

        </div> */}


        {/* Free Delivery */}

        {/* <div
          style={{
            background: "white",
            padding: "12px",
            borderRadius: "12px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
        >

          <div
            style={{
              background: "#e8f0ff",
              color: "#2979ff",
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px"
            }}
          >
            <FiTruck />
          </div>

          <div>
            <div style={{ fontSize: "12px", color: "#666", whiteSpace: "nowrap" }}>
              Free delivery above
            </div>
            <div style={{ fontWeight: "bold", fontSize: "16px" }}>
              ₹{DELIVERY_THRESHOLD}
            </div>
          </div>

        </div> */}

      </div>

      <div
        style={{
          position: "sticky",
          top: "52px",
          zIndex: 99,
          transform: showSearch ? "translateY(0)" : "translateY(-100%)",
          transition: "transform 0.25s ease",
          background: "#f7f7f7",
          paddingTop: "8px",
        }}
      >

        <div style={{ position: "relative" }}>
          <FiSearch
            size={16}
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#888",

            }}
          />

          <input
            type="text"
            placeholder=" Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              // position: "sticky",      // ADD THIS
              // top: "52px",             // ADD THIS — sits just below your header
              // zIndex: 99,
              width: "100%",
              padding: "10px 10px 10px 36px",
              borderRadius: "10px",
              border: "1px solid #ddd",
              marginBottom: "0px",
              fontSize: "14px",
              boxSizing: "border-box",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              background: "#f7f7f7",   // ← ADD THIS
              paddingBottom: "8px",
            }}
          />
        </div>

      </div>



      <div
        style={{
          position: "sticky",
          top: showSearch ? "85px" : "52px", // 🔥 KEY MAGIC
          zIndex: 98,
          background: "#f7f7f7",
          padding: "16px 0 8px 0",
          marginBottom: "12px",
          overflowX: "auto",
          display: "flex",
          gap: "10px",
          scrollbarWidth: "none",
          transform: showSearch ? "translateY(0px)" : "translateY(0)", // 🔥 MAGIC
          transition: "transform 0.25s ease",
          willChange: "transform"
        }}
      >

        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              border: "1px solid #ddd",
              fontFamily: "'Nunito', sans-serif",  // ADD THIS
              fontWeight: selectedCategory === cat ? "700" : "600",
              background: selectedCategory === cat ? "#16a34a" : "white",
              color: selectedCategory === cat ? "white" : "black",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              fontSize: "13px",
              boxShadow: selectedCategory === cat ? "0 3px 6px rgba(0,0,0,0.15)" : "none"
            }}
          >
            {categoryIcons[cat]}
            {cat}
          </button>
        ))}

      </div>



      {loading ? (

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "12px"
          }}
        >

          {[...Array(8)].map((_, i) => (

            <div
              key={i}
              style={{
                background: "#eee",
                borderRadius: "12px",
                height: "190px",
                animation: "pulse 1.2s infinite"
              }}
            />

          ))}

        </div>

      ) : (

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
          gap: "12px"
        }}>

          {filteredProducts.map(product => (

            <div
              key={product._id}
              style={{
                background: "white",
                padding: "10px",
                borderRadius: "16px",
                boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
                textAlign: "left",

                opacity: product.stock === 0 ? 0.6 : 1,
                filter: product.stock === 0 ? "grayscale(40%)" : "none",
                pointerEvents: product.stock === 0 ? "none" : "auto"
              }}
              onMouseEnter={(e) => {
                if (window.innerWidth > 768) {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
                }
              }}
              onMouseLeave={(e) => {
                if (window.innerWidth > 768) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.08)";
                }
              }}
            >

              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "110px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "6px"
                }}
              >
                <img
                  ref={(el) => {
                    if (el) imgRefs.current[product._id] = el;
                  }}   // ✅ ADD THIS
                  src={product.image || "/no-image.png"}
                  alt={product.name}
                  style={{
                    maxHeight: "110px",
                    maxWidth: "100%",
                    objectFit: "contain"
                  }}
                />

                {product.stock === 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(255,255,255,0.6)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                      borderRadius: "10px"
                    }}
                  >
                    Out of Stock
                  </div>
                )}

                {/* Floating + button */}
                {!product.hasVariants && (
                  <button
                    disabled={!product.active || product.stock === 0}
                    onClick={() => {
                      if (product.hasVariants) return; // 🚫 block
                      addToCart(product);
                    }}
                    style={{
                      position: "absolute",
                      bottom: "-6px",
                      right: "-6px",
                      width: "34px",
                      height: "34px",
                      borderRadius: "10px",
                      border: product.stock === 0 ? "0px" : "2px solid #ff2d6f",
                      background: product.stock === 0 ? "#eee" : "white",
                      fontSize: "20px",
                      fontWeight: "bold",
                      cursor: product.stock === 0 ? "not-allowed" : "pointer",
                      color: product.stock === 0 ? "#aaa" : "#ff2d6f",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.15)"
                    }}
                  >
                    +
                  </button>
                )}
              </div>

              <h3
                style={{
                  fontSize: "14px",
                  margin: "4px 0",
                  fontWeight: "700",
                  fontFamily: "'Nunito', sans-serif",
                  minHeight: "36px",
                  lineHeight: "18px"
                }}
              >
                {capitalizeWords(product.name)}
              </h3>

              {!product.hasVariants && product.packSize && product.unit && (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#065f46",
                    background: "#d1fae5",
                    display: "inline-block",
                    padding: "2px 6px",
                    borderRadius: "6px",
                    fontWeight: "600",
                    margin: "4px 0 6px 0"
                  }}
                >
                  {product.packSize && product.unit
                    ? `${product.packSize}${product.unit}`
                    : ""}
                </p>
              )}

              <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                <span style={{ fontWeight: "700", fontSize: "16px", fontFamily: "'Inter', sans-serif", color: "#111" }}>
                  ₹{product.hasVariants
                    ? `From ₹${Math.min(...product.variants.map(v => v.price))}`
                    : product.price}
                </span>

                {product.mrp && product.mrp > product.price && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "#888",
                      fontSize: "14px"
                    }}
                  >
                    ₹{product.mrp}
                  </span>
                )}
              </div>

              <div style={{ minHeight: "18px", marginBottom: "6px" }}>
                {product.mrp && product.mrp > product.price && (
                  <div
                    style={{
                      color: "#16a34a",
                      fontSize: "13px",
                      fontWeight: "600"
                    }}
                  >
                    ₹{product.mrp - product.price} OFF
                  </div>
                )}
              </div>



              {product.stock === 0 ? (

                <p
                  style={{
                    background: "#ffe6e6",
                    color: "#b30000",
                    padding: "8px 6px",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Out of Stock
                </p>

              ) : product.hasVariants ? (

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginTop: "6px"
                }}>
                  {[...product.variants]
                    .sort((a, b) => a.quantity - b.quantity)
                    .map(v => {
                      const qty = getQuantity(product._id, v.quantity);

                      return (
                        <div
                          key={v.quantity}
                          style={{
                            border: "1px solid #16a34a",
                            padding: "6px 8px",
                            borderRadius: "6px",
                            background: qty > 0 ? "#dcfce7" : "#f9fafb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            minWidth: "0",
                            gap: "6px"
                          }}
                        >
                          <div style={{ fontSize: "12px", fontWeight: "500" }}>
                            {v.quantity}{v.unit} ₹{v.price}
                          </div>

                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}>

                            <button
                              onClick={(e) => {
                                const btn = e.currentTarget;

                                decreaseQuantity({
                                  ...product,
                                  key: `${product._id}-${v.quantity}`
                                });

                                // 🔥 bounce
                                btn.classList.remove("add-bounce");
                                void btn.offsetWidth;
                                btn.classList.add("add-bounce");

                                navigator.vibrate?.(10);
                              }}
                              disabled={qty === 0}
                              style={{
                                background: qty === 0 ? "#e5e5e5" : "#16a34a",
                                color: qty === 0 ? "#888" : "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                cursor: qty === 0 ? "not-allowed" : "pointer",
                                opacity: qty === 0 ? 0.5 : 1,

                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "14px",
                              }}
                            >
                              −
                            </button>

                            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                              {qty}
                            </span>

                            <button
                              onClick={(e) => {
                                if (qty >= product.stock) return;

                                const btn = e.currentTarget;

                                addToCart({ ...product, selectedVariant: v });

                                // 🔥 bounce
                                btn.classList.remove("add-bounce");
                                void btn.offsetWidth;
                                btn.classList.add("add-bounce");

                                navigator.vibrate?.(10);
                              }}
                              disabled={qty >= product.stock}
                              style={{
                                background: "#16a34a",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                cursor: qty >= product.stock ? "not-allowed" : "pointer",
                                opacity: qty >= product.stock ? 0.5 : 1,

                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "14px",
                              }}
                            >
                              +
                            </button>

                          </div>
                        </div>
                      );
                    })}
                </div>

              ) : getQuantity(product._id) === 0 ? (

                <button
                  onClick={(e) => {

                    const rect = e.currentTarget
                      .closest("div")
                      .querySelector("img")
                      ?.getBoundingClientRect();

                    if (rect) flyToCart(rect);   // ✅ TRIGGER ANIMATION

                    setJustAdded(product._id);

                    setTimeout(() => {
                      addToCart(product);
                    }, 0);

                    setTimeout(() => {
                      setJustAdded(null);        // reset after animation
                    }, 300);
                  }}
                  style={{
                    background: "#16a34a",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontFamily: "'Nunito', sans-serif",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",

                    transform: justAdded === product._id ? "scale(0.8)" : "scale(1)",
                    opacity: justAdded === product._id ? 0 : 1,
                    transition: "all 0.2s ease",
                    willChange: "transform, opacity",
                  }}
                >
                  ADD
                </button>

              ) : (

                <div
                  key={product._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#16a34a",
                    color: "white",
                    borderRadius: "8px",
                    padding: "4px 8px",
                    width: justAdded === product._id ? "60px" : "90px",
                    margin: "auto",
                    fontWeight: "bold",

                    transform: justAdded === product._id ? "scale(0.6)" : "scale(1)",
                    opacity: justAdded === product._id ? 0 : 1,
                    transition: "all 0.25s cubic-bezier(0.2, 1.2, 0.4, 1)"
                  }}
                >

                  <button
                    onClick={(e) => {
                      const btn = e.currentTarget;

                      decreaseQuantity({
                        ...product,
                        key: product._id
                      });

                      btn.classList.remove("add-bounce");
                      void btn.offsetWidth;
                      btn.classList.add("add-bounce");

                      navigator.vibrate?.(10);
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "16px",
                      cursor: "pointer"
                    }}
                  >
                    −
                  </button>

                  <span>{getQuantity(product._id)}</span>

                  <button
                    onClick={(e) => {

                      if (getQuantity(product._id) >= product.stock) return;

                      const btn = e.currentTarget;

                      addToCart(product);

                      btn.classList.remove("add-bounce");
                      void btn.offsetWidth; // force reflow to restart animation
                      btn.classList.add("add-bounce");

                    }}
                    disabled={getQuantity(product._id) >= product.stock}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: getQuantity(product._id) >= product.stock ? "#b5e6b5" : "white",
                      fontSize: "16px",
                      cursor: getQuantity(product._id) >= product.stock ? "not-allowed" : "pointer",
                      opacity: getQuantity(product._id) >= product.stock ? 0.5 : 1
                    }}
                  >
                    +
                  </button>

                </div>



              )}

              {product.stock > 0 && product.stock <= 3 && (
                <p className="stock-warning" style={{ color: "#ff8800", fontSize: "12px" }}>
                  Only {product.stock} left
                </p>
              )}


            </div>

          ))}

        </div>

      )}

      {/* CART SECTION */}

      <h2
        ref={cartSectionRef}
        style={{
          marginTop: "40px",
          marginBottom: "15px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontFamily: "'Nunito', sans-serif",
        }}
      >
        <FiShoppingCart size={22} />
        Your Cart
      </h2>

      {cart.length === 0 && (
        <p style={{ color: "gray" }}>Your cart is empty</p>
      )}

      {cart.length > 0 && (

        <div style={{ marginTop: "20px" }}>

          {cart.map(item => (

            <div
              key={item.key}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                marginBottom: "12px",
                borderRadius: "10px",
                background: "white",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                fontFamily: "'Nunito', sans-serif",
              }}
            >

              <img
                src={item.image || "/no-image.png"}
                alt={item.name}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  borderRadius: "8px"
                }}
              />

              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold" }}>
                  {capitalizeWords(item.name)}
                  {item.packSize && item.unit && (
                    <span style={{ fontSize: "12px", color: "#777", marginLeft: "6px" }}>
                      ({item.packSize}{item.unit})
                    </span>
                  )}
                </div>
                <div style={{ fontSize: "13px", color: "gray" }}>₹{item.price}</div>
                <div style={{ fontSize: "13px", color: "#444", fontWeight: "500" }}>
                  Subtotal ₹{item.price * item.quantity}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f5f5f5",
                  borderRadius: "30px",
                  padding: "4px",
                  gap: "6px"
                }}
              >

                <button
                  onClick={() => decreaseQuantity(item)}
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    border: "none",
                    background: "#0aad0a",
                    color: "white",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "16px"
                  }}
                >
                  −
                </button>

                <span
                  style={{
                    minWidth: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "14px"
                  }}
                >
                  {item.quantity}
                </span>

                <button
                  onClick={() => addToCart(item)}
                  disabled={item.quantity >= item.stock}
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    border: "none",
                    background: item.quantity >= item.stock ? "#cfe9cf" : "#0aad0a",
                    color: item.quantity >= item.stock ? "#6aaa6a" : "white",
                    fontWeight: "bold",
                    cursor: item.quantity >= item.stock ? "not-allowed" : "pointer",
                    fontSize: "16px",
                    opacity: item.quantity >= item.stock ? 0.6 : 1
                  }}
                >
                  +
                </button>

              </div>

            </div>

          ))}

          {/* CHECKOUT */}

          <div style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            marginTop: "20px"
          }}>

            <h3
              style={{
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              <FiPackage size={18} />
              Order Summary
            </h3>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
              <span>Subtotal</span>
              <span>₹{totalPrice}</span>
            </div>

            {/* Delivery fee calculation */}

            {/* <div style={{ marginBottom: "10px" }}>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Delivery</span>

                <span
                  style={{
                    color: deliveryFee === 0 ? "#0aad0a" : "black",
                    fontWeight: deliveryFee === 0 ? "bold" : "normal"
                  }}
                >
                  {deliveryFee === 0 ? "FREE" : `₹${DELIVERY_FEE}`}
                </span>
              </div>

              {deliveryFee !== 0 && (

                <div style={{ marginTop: "6px" }}>

                  <p style={{
                    fontSize: "12px",
                    color: "#0aad0a",
                    fontWeight: "500",
                    marginBottom: "6px"
                  }}>
                    Add items worth ₹{DELIVERY_THRESHOLD - totalPrice} or more for free delivery
                  </p>

                  <div style={{
                    height: "6px",
                    background: "#e5e5e5",
                    borderRadius: "10px",
                    overflow: "hidden"
                  }}>

                    <div style={{
                      height: "100%",
                      width: `${progress}%`,
                      background: "#16a34a",
                      transition: "width 0.3s ease"
                    }} />

                  </div>

                </div>

              )}

              {deliveryFee === 0 && (
                <p style={{
                  fontSize: "12px",
                  color: "#16a34a",
                  fontWeight: "600",
                  marginTop: "6px"
                }}>
                  🎉 You unlocked FREE delivery!
                </p>
              )}

            </div>{ } */}

            <hr style={{ border: "none", borderTop: "1px solid #eee" }} />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "10px"
              }}
            >
              <span>Total</span>
              <span>₹{finalTotal}</span>
            </div>

            <h3
              // 🔥 IMPORTANT (triggers animation)
              style={{
                marginTop: "30px",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "6px",

                // ✨ animation
                animation: "fadeSlide 0.25s ease"
              }}
            >
              {orderType === "delivery" ? (
                <>
                  <MdLocalShipping size={20} />
                  Delivery Address
                </>
              ) : (
                <>
                  <FiShoppingBag size={18} />
                  Pickup
                </>
              )}
            </h3>

            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>

              <button
                onClick={() => setOrderType("delivery")}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "8px",
                  border: orderType === "delivery" ? "1.5px solid #2563eb" : "1px solid #ddd",
                  background: orderType === "delivery" ? "#eff6ff" : "white",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  transform: orderType === "delivery" ? "scale(1.02)" : "scale(1)",
                  boxShadow: orderType === "delivery"
                    ? "0 2px 6px rgba(37,99,235,0.15)"
                    : "none"
                }}
              >
                <span style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "center",
                  color: orderType === "delivery" ? "#2563eb" : "#333"
                }}>
                  <MdLocalShipping size={18} />
                  Delivery
                </span>
              </button>



              <button
                onClick={() => setOrderType("pickup")}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "8px",
                  border: orderType === "pickup" ? "1.5px solid #16a34a" : "1px solid #ddd",
                  background: orderType === "pickup" ? "#f0fdf4" : "white",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  transform: orderType === "pickup" ? "scale(1.02)" : "scale(1)",
                  boxShadow: orderType === "pickup"
                    ? "0 2px 6px rgba(22,163,74,0.2)"
                    : "none"
                }}
              >
                <span style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "center",
                  color: orderType === "pickup" ? "#16a34a" : "#333"
                }}>
                  <FiShoppingBag size={17} />
                  Pickup
                </span>
              </button>


            </div>



            {orderType === "pickup" && (
              <div style={{
                marginTop: "10px",
                padding: "12px",
                borderRadius: "10px",
                background: "#f0fdf4",
                border: "1px solid #bbf7d0"
              }}>

                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontWeight: "600",
                  marginBottom: "4px"
                }}>
                  <FiMapPin size={16} />
                  Store Location
                </div>

                <div style={{ fontSize: "13px", color: "#444" }}>
                  Manasa Stores, B.C Road
                </div>

                <a
                  href="https://www.google.com/maps?q=12.881111,75.024194"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    marginTop: "6px",
                    fontSize: "13px",
                    color: "#2563eb",
                    fontWeight: "600",
                    textDecoration: "none"
                  }}
                >
                  View on Google Maps →
                </a>

              </div>
            )}

            <div
              key={orderType} // 🔥 triggers animation on switch
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                animation: "formSlide 0.25s ease"
              }}
            >

              <div style={{ position: "relative" }}>
                <FiUser
                  size={18}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#888"
                  }}
                />

                <input
                  name="customerName"
                  placeholder="Your Name"
                  value={customer.customerName}
                  onChange={handleCustomerChange}
                  style={{
                    width: "100%",
                    padding: "12px 12px 12px 36px",
                    fontFamily: "'Inter', sans-serif",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                    outline: "none",
                    boxSizing: "border-box",
                    background: "#fafafa"
                  }}
                />
              </div>

              <div style={{ position: "relative" }}>
                <FiPhone
                  size={18}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#888"
                  }}
                />

                <input
                  name="phone"
                  type="tel"
                  inputMode="numeric"
                  placeholder="Phone Number"
                  value={customer.phone}
                  maxLength={10}
                  pattern="[0-9]*"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

                    handleCustomerChange({
                      target: { name: "phone", value }
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "12px 12px 12px 36px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                    outline: "none",
                    boxSizing: "border-box",
                    background: "#fafafa"
                  }}
                />
              </div>

              {/* Address (for delivery) */}

              {orderType === "delivery" && (
                <div style={{ position: "relative" }}>
                  <FiMapPin
                    size={18}
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "14px",
                      color: "#888"
                    }}
                  />

                  <textarea
                    name="address"
                    placeholder="Delivery Address"
                    value={customer.address || ""}
                    onChange={handleCustomerChange}
                    rows="3"
                    style={{
                      width: "100%",
                      padding: "12px 12px 12px 36px",
                      borderRadius: "8px",

                      fontSize: "14px",
                      resize: "none",
                      outline: "none",
                      boxSizing: "border-box",
                      minHeight: "70px",
                      background: "#fafafa",
                      border: "1px solid #e5e7eb"
                    }}
                  />
                </div>
              )}

              <div style={{ position: "relative" }}>
                <textarea
                  name="note"
                  placeholder="Special request (optional)"
                  value={customer.note || ""}
                  onChange={handleCustomerChange}
                  rows="2"
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "14px",
                    resize: "none",
                    outline: "none",
                    boxSizing: "border-box"
                  }}
                />
              </div>

              {orderType === "delivery" && (
                <button onClick={() => setShowMap(true)}
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #bfdbfe",
                    background: "#eff6ff",
                    color: "#1d4ed8",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    fontWeight: "600"
                  }}
                >
                  <FiMapPin size={16} /> Choose location on map
                </button>
              )}

              {orderType === "delivery" && showMap && (
                <LocationPicker
                  setLocation={(coords) => {
                    setLocation(coords);

                    setCustomer((prev) => ({
                      ...prev,
                      lat: coords.lat,
                      lng: coords.lng
                    }));
                  }}
                  setShowMap={setShowMap}

                />
              )}

              {/* <p style={{
                fontSize: "13px",
                color: "#b45309",
                fontWeight: "600",
                marginTop: "10px",
                display: "flex",
                alignItems: "center",   // 🔥 key fix
                gap: "6px",
                lineHeight: "1"         // 🔥 prevents vertical shift
              }}>
                <FiAlertTriangle size={14} style={{ flexShrink: 0 }} />
                <span>Store pickup only — no home delivery</span>
              </p> */}

              <button
                onClick={() => {
                  const currentType = orderType;

                  if (validateOrder(currentType)) {
                    setShowConfirm(true);
                  }
                }}
                disabled={placingOrder || !isShopOpen()}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  padding: "16px",
                  background: placingOrder ? "#9ca3af" : "#0aad0a",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  fontFamily: "'Nunito', sans-serif",  // ADD THIS
                  fontWeight: "800",
                  fontSize: "17px",
                  cursor: placingOrder ? "not-allowed" : "pointer",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  opacity: placingOrder ? 0.8 : 1
                }}
              >
                <MdOutlineShoppingCartCheckout size={20} />

                {!isShopOpen()
                  ? "Closed (Outside Hours)"
                  : placingOrder
                    ? "Placing Order..."
                    : `Place Order (${orderType === "pickup" ? "Pickup" : "Delivery"})`}
              </button>

            </div>

          </div>

        </div>

      )}
      <ToastContainer position="top-center" autoClose={2000} />

      {showTopBtn && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "80px",
            right: "16px",
            zIndex: 1000,

            width: "44px",
            height: "44px",
            borderRadius: "50%",
            border: "none",

            background: "#111827",
            color: "white",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            cursor: "pointer",

            // 🔥 ANIMATION MAGIC
            opacity: showTopBtn ? 1 : 0,
            transform: showTopBtn
              ? "translateY(0px) scale(1)"
              : "translateY(20px) scale(0.8)",
            pointerEvents: showTopBtn ? "auto" : "none",

            transition: "all 0.25s ease"
          }}
        >
          <FiArrowUp size={20} />
        </button>
      )}

      {showConfirm && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000
        }}>
          <div style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            width: "90%",
            maxWidth: "350px",
            textAlign: "center",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
          }}>
            <h3 style={{
              marginBottom: "10px",
              fontFamily: "'Nunito', sans-serif",
              fontWeight: "800",
              fontSize: "18px",
              color: "#111",
              letterSpacing: "0.5px"
            }}>
              Confirm Order
            </h3>

            <p style={{
              fontSize: "14px",
              color: "#555",
              marginBottom: "20px",
              fontFamily: "'Inter', sans-serif"
            }}>
              Confirm your {orderType === "delivery" ? "delivery" : "pickup"} order of ₹{finalTotal}?
            </p>

            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  background: "#f5f5f5",
                  cursor: "pointer",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "600"
                }}
              >
                Cancel
              </button>

              <button
                disabled={placingOrder}   // 🔥 ADD HERE
                onClick={() => {

                  if (placingOrder) return;
                  setShowConfirm(false);

                  const currentType = orderType;

                  placeOrder(currentType);
                }}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "8px",
                  border: "none",
                  background: placingOrder ? "#9ca3af" : "#16a34a", // 👈 optional visual
                  color: "white",
                  fontWeight: "700",
                  cursor: placingOrder ? "not-allowed" : "pointer",
                  fontFamily: "'Inter', sans-serif"
                }}
              >
                {placingOrder ? "Placing..." : "Confirm"}   {/* 🔥 optional upgrade */}
              </button>
            </div>
          </div>
        </div>
      )}

      {
        placingOrder && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3000
          }}>
            <div style={{
              background: "white",
              padding: "25px",
              borderRadius: "12px",
              textAlign: "center",
              width: "80%",
              maxWidth: "300px"
            }}>

              <div className="spinner" />

              <div style={{
                marginBottom: "15px",
                fontSize: "18px",
                fontWeight: "700"
              }}>
                Placing your order...
              </div>

              <div style={{
                fontSize: "13px",
                color: "#666"
              }}>
                Please do not close this page
              </div>

            </div>
          </div>
        )
      }




    </div>


  );
}

export default Products;